import { OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
var SearchableDropdownComponent = /** @class */ (function () {
    function SearchableDropdownComponent() {
        this.selectedDropDowns = new EventEmitter();
    }
    SearchableDropdownComponent.prototype.ngOnInit = function () {
        this.applyInitialSelectionFromDropdownData();
    };
    SearchableDropdownComponent.prototype.ngOnChanges = function (changes) {
        if (changes.dropdownData) {
            this.applyInitialSelectionFromDropdownData();
        }
    };
    SearchableDropdownComponent.prototype.applyInitialSelectionFromDropdownData = function () {
        var init = this.dropdownData && this.dropdownData.initialSelected;
        if (init && Array.isArray(init) && init.length > 0) {
            this.selectedValues = init.slice();
        }
    };
    SearchableDropdownComponent.prototype.chosenOptions = function () {
        var _a;
        var emitSelections = (_a = {},
            _a[this.dropdownData.key] = this.selectedValues,
            _a);
        this.selectedDropDowns.emit(emitSelections);
    };
    return SearchableDropdownComponent;
}());
export { SearchableDropdownComponent };
